import React from 'react'

export default function Arrowrighticon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 11 11" fill="none">
            <path d="M1 1L10 1M10 1L10 10M10 1L1 10" stroke="currentColor"></path>
        </svg>
    )
}
